import { Button } from "@benefit-systems/common-components";
import { FC } from "react";

import Modal from "web/Pages/Checkout/Subscription/Modal";

import __ from "web/Layout/Translations";

import { DUPLICATE_ACTION_TYPES, DUPLICATE_CALL } from "web/constants/benefits";

import { ISubscriptionItemCurrentUserSubscription } from "web/types/Subscription";

import modalClasses from "../duplicateSuccessModal.scss";

interface IDoubledDataModalHandlerProps {
  showDuplicateForm: string;
  setShowDuplicateFormInformationStep: (arg: boolean) => void | null;
  handleToggleDuplicateModal: (
    item: ISubscriptionItemCurrentUserSubscription
  ) => void;
  updatedItem: ISubscriptionItemCurrentUserSubscription;
  closeModal: () => void;
}

const DoubledDataModalHandler: FC<IDoubledDataModalHandlerProps> = ({
  showDuplicateForm,
  setShowDuplicateFormInformationStep,
  handleToggleDuplicateModal,
  updatedItem,
  closeModal,
}) => {
  const { cancel, correct } = DUPLICATE_ACTION_TYPES;

  const doubledDataModalHandler = (actionType: string) => {
    if (showDuplicateForm === DUPLICATE_CALL.from_desktop) {
      if (actionType === cancel) closeModal();
      if (actionType === correct) handleToggleDuplicateModal(updatedItem);
    }

    if (showDuplicateForm === DUPLICATE_CALL.from_stepTwo) {
      closeModal();
      if (actionType === cancel) setShowDuplicateFormInformationStep(false);
    }
  };

  return (
    <Modal classes={modalClasses}>
      <div className={modalClasses.modalWrapper}>
        <span className={modalClasses.text__sameData}>
          {__("Wpisane nowe dane są takie same jak dotychczas")}
        </span>
        <span className={modalClasses.subText}>
          {__(
            "Nie ma możliwości zamówienia duplikatu z powodu zmiany danych personalnych"
          )}
        </span>
        <div className={modalClasses.buttonsWrapper}>
          <Button
            type="button"
            variant="secondary"
            transparent
            onClick={() => doubledDataModalHandler(cancel)}
          >
            {__("Anuluj zamówienie")}
          </Button>

          <Button
            type="button"
            variant="tertiary"
            onClick={() => doubledDataModalHandler(correct)}
          >
            {__("Zmień dane / powód")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DoubledDataModalHandler;
